import { render, staticRenderFns } from "./Nominations.vue?vue&type=template&id=0b591e80&scoped=true&"
import script from "./Nominations.vue?vue&type=script&lang=js&"
export * from "./Nominations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b591e80",
  null
  
)

export default component.exports